import PropTypes from 'prop-types'
import { Button as BsButton, Form, Alert } from 'react-bootstrap'
import { Button } from 'antd'

const Login = (props) => {
  const {
    onChange,
    onSubmit,
    form,
    errMessage,
    isSubmit,
    handleSwitchLogin,
    isLogin,
    isSubmitForgot,
    onSubmitForgot,
  } = props

  return (
    <div
      className="form-container d-flex align-items-center"
      style={{
        // backgroundImage: 'url(./assets/bg_dplk.svg)',
        height: '100vh',
        // backgroundSize: 'cover',
        backgroundColor: '#f9f9f9',
      }}
    >
      {isLogin
        ? (
          <Form className="form-signin px-3 py-4 card-login" onSubmit={onSubmit}>
            {/* <img className="mb-4" style={{maxWidth: '100%', height: '150px'}} src="./assets/logo.png" alt="logo" /> */}
            <div className="mb-3">
              <h5 className="primary-color mb-1">Selamat Datang di</h5>
              <h5 className="primary-color">Admin Dashboard</h5>
            </div>

            <Form.Control onChange={onChange} value={form.email || ''} name="email" type="text" placeholder="Email Address" className="mb-2" />
            <Form.Control onChange={onChange} value={form.password || ''} name="password" type="password" placeholder="Password" className="mb-2" />

            {errMessage && <Alert variant="danger">{errMessage}</Alert>}
            <div className="mt-5">
              {<Button type="link" className="px-0" onClick={handleSwitchLogin}>Lupa password</Button>}
              <BsButton className="w-100" variant="primary" disabled={isSubmit} type="submit">Masuk</BsButton>
            </div>
          </Form>
        )
        : (
          <Form className="form-signin px-3 py-5" onSubmit={onSubmitForgot}>
            {/* <img className="mb-4 w-100" src="./assets/bgs.jpg" alt="logo" /> */}
            <div className="mb-3">
              <h5 className="primary-color mb-1">Lupa Password?</h5>
              <p style={{ color: '#495057' }}>
                Masukan email yang terdaftar untuk mendapatkan <i>reset link</i>
              </p>
            </div>
            <div className="card-login">
              <Form.Control onChange={onChange} value={form.email || ''} name="email" type="text" placeholder="Email Address" className="mb-2" />
              {errMessage && <Alert variant="danger">{errMessage}</Alert>}
              <div className="d-flex justify-content-between mt-5">
                <Button type="link" className="px-0" onClick={handleSwitchLogin}>Masuk</Button>
                <BsButton variant="primary" disabled={isSubmitForgot} type="submit">Kirim</BsButton>
                {/* <Button type="primary" disabled={isSubmit}>Sign in</Button> */}
              </div>
            </div>
          </Form>
        )
      }

    </div>
  )
}

Login.propTypes = {
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  form: PropTypes.any,
  isSubmit: PropTypes.bool,
  handleSwitchLogin: PropTypes.func,
  isLogin: PropTypes.bool,
  isSubmitForgot: PropTypes.bool,
  onSubmitForgot: PropTypes.func,
  errMessage: PropTypes.string,
}

export default Login
